import React from "react";
import colors from "../theme/colors";
import radius from "../theme/radius";
import typography from "../theme/typography";

const baseVariantMap = {
  default: {
    background: colors.highlight,
    color: colors.primaryDark,
    border: `1px solid ${colors.border}`,
  },
  soft: {
    background: colors.highlight,
    color: colors.primaryDark,
    border: `1px solid ${colors.border}`,
  },
  primary: {
    background: colors.primarySoft,
    color: colors.primaryDark,
    border: `1px solid ${colors.border}`,
  },
};

function getStatusStyles(status) {
  switch (status) {
    case "success":
      return {
        background: colors.statusSuccessSoft,
        color: colors.statusSuccess,
        border: `1px solid ${colors.statusSuccess}`,
      };
    case "warning":
      return {
        background: colors.statusWarningSoft,
        color: colors.statusWarning,
        border: `1px solid ${colors.statusWarning}`,
      };
    case "danger":
      return {
        background: colors.statusDangerSoft,
        color: colors.statusDanger,
        border: `1px solid ${colors.statusDanger}`,
      };
    case "neutral":
    default:
      return {
        background: colors.statusNeutralSoft,
        color: colors.statusNeutral,
        border: `1px solid ${colors.statusNeutral}`,
      };
  }
}

export default function Badge({
  children,
  variant = "default",
  status,
  size = "sm",
  style = {},
  className = "",
  as: Component = "span",
}) {
  const palette =
    variant === "status"
      ? getStatusStyles(status)
      : baseVariantMap[variant] || baseVariantMap.default;

  const sizeMap = {
    sm: {
      minHeight: 20,
      padding: "3px 10px",
      fontSize: "10px",
      lineHeight: "12px",
    },
    md: {
      minHeight: 24,
      padding: "4px 12px",
      fontSize: typography.size.xs,
      lineHeight: typography.lineHeight.tight,
    },
  };

  const resolvedSize = sizeMap[size] || sizeMap.sm;

  return (
    <Component
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: resolvedSize.minHeight,
        padding: resolvedSize.padding,
        borderRadius: radius.pill,
        background: palette.background,
        color: palette.color,
        border: palette.border,
        fontFamily: typography.fontFamily,
        fontSize: resolvedSize.fontSize,
        fontWeight: typography.weight.bold,
        lineHeight: resolvedSize.lineHeight,
        whiteSpace: "nowrap",
        boxSizing: "border-box",
        ...style,
      }}
    >
      {children}
    </Component>
  );
}